// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrimaryButton_primaryButton__bwC-O {
  display: inline-block;
  padding: 12px 24px;
  margin-left: 20px;
  background: white;
  color: black;
  text-decoration: none;
  letter-spacing: 0.1rem;
  font-weight: 600;
  font-size: 13px;
  transition: all 0.3s ease;
  clip-path: polygon(
    10% 0%,
    100% 0%,
    100% 70%,
    90% 100%,
    0% 100%,
    0% 30%
  );
}

.PrimaryButton_primaryButton__bwC-O:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 149, 255, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/components/Buttons/PrimaryButton/PrimaryButton.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB;;;;;;;GAOC;AACH;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C","sourcesContent":[".primaryButton {\n  display: inline-block;\n  padding: 12px 24px;\n  margin-left: 20px;\n  background: white;\n  color: black;\n  text-decoration: none;\n  letter-spacing: 0.1rem;\n  font-weight: 600;\n  font-size: 13px;\n  transition: all 0.3s ease;\n  clip-path: polygon(\n    10% 0%,\n    100% 0%,\n    100% 70%,\n    90% 100%,\n    0% 100%,\n    0% 30%\n  );\n}\n\n.primaryButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 149, 255, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryButton": `PrimaryButton_primaryButton__bwC-O`
};
export default ___CSS_LOADER_EXPORT___;
